export default __webpack_public_path__ + "static/lifecycle-dark-64ab2636eaf218bea8a149691650650c.png";